import { render, staticRenderFns } from "./CardHoverPrice.vue?vue&type=template&id=13315854&"
import script from "./CardHoverPrice.vue?vue&type=script&lang=js&"
export * from "./CardHoverPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports